<div style="background: rgb(209,203,184,.7); margin-right:0px">
    <div class="row blackText text-center mainContainer" *ngIf="!this.myHarrellsService.onlineOrderingInEffect">
        <div class="col-2"></div>
        <div class="col-lg-4 greenText tbaContainer">
            <h4 class="Caecilia76BoldItalic tbaHeader">
                Take a Balanced<br>Approach to<br>Growth</h4>
            <h6 class="DIN2014Regular blackText tbaSubHeader">
                Harrell's Balanced Approach is a scientifically supported, integrated, and proactive use of
                agronomic
                resources to maximize plant health and consistency.</h6>
        </div>
        <div class="col-lg-4 tbaIconsContainer">
            <div class="row">
                <div class="col-6 g-0" style="padding-top:10%">
                    <div style="margin:auto;height:50px; width:50px;"><img style="margin-top:8px; width:50px"
                            src="{{this.pageImagePaths + 'soil-icon.png'}}" alt="soilIcon"></div>
                    <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px">SOIL</h4>
                    <div style="margin:auto;height:50px; width:50px; padding-top:30px"><img
                            style="margin-top:8px; width:50px" src="{{this.pageImagePaths + 'water-icon.png'}}"
                            alt="soilIcon"></div>
                    <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px; padding-top:30px">WATER
                    </h4>
                </div>
                <div class="col-6" style="padding-top:10%">
                    <div style="margin:auto;height:50px; width:50px;"><img style="margin-top:8px; width:50px"
                            src="{{this.pageImagePaths + 'nutrition-icon.png'}}" alt="soilIcon"></div>
                    <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px">NUTRITION</h4>
                    <div style="margin:auto;height:50px; width:50px; padding-top:30px"><img
                            style="margin-top:8px; width:50px" src="{{this.pageImagePaths + 'protection-icon.png'}}"
                            alt="soilIcon"></div>
                    <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px; padding-top:30px">
                        PROTECTION
                    </h4>
                </div>
            </div>
        </div>
        <div class="col-2"></div>
    </div>
</div>